export default __webpack_public_path__ + "static/media/3-min.43a1df86.jpg";